import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AdhvaPrelimsPath2026Page = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div style={{ 
      fontFamily: "'Inter', sans-serif", 
      backgroundColor: '#f8fafc', 
      color: '#1e293b',
      backgroundImage: 'url("https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      minHeight: '100vh'
    }}>
      <Navbar />
      
      {/* Hero Section */}
      <header style={{
        position: 'relative',
        paddingTop: isMobile ? '3rem' : '5rem',
        paddingBottom: isMobile ? '4rem' : '7rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: isMobile ? '55vh' : '70vh',
        backgroundImage: 'url("https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#0f172a',
          opacity: 0.75
        }}></div>
        <div className="container" style={{
          position: 'relative',
          zIndex: 10,
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1.5rem',
          textAlign: 'center',
          marginTop: isMobile ? '4rem' : '6rem'
        }}>
          <span style={{
            display: 'inline-block',
            padding: isMobile ? '0.375rem 0.75rem' : '0.5rem 1rem',
            borderRadius: '9999px',
            backgroundColor: '#2563eb',
            color: 'white',
            fontSize: isMobile ? 'clamp(0.65rem, 2vw, 0.7rem)' : '0.75rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: isMobile ? '0.75rem' : '1rem'
          }}>
            UPSC Prelims Test Series
          </span>
          <h1 style={{
            color: 'white',
            fontWeight: 800,
            fontSize: isMobile ? 'clamp(1.5rem, 5vw, 2.25rem)' : 'clamp(2rem, 5vw, 3rem)',
            marginBottom: isMobile ? '0.75rem' : '1rem',
            lineHeight: 1.2
          }}>
            ADHVA PRELIMS PATH <span style={{ color: '#60a5fa' }}>2026</span>
          </h1>
          <p style={{
            fontSize: isMobile ? 'clamp(0.875rem, 2.5vw, 1rem)' : 'clamp(1rem, 2vw, 1.125rem)',
            color: 'white',
            maxWidth: '42rem',
            margin: isMobile ? '0.75rem auto 1.5rem' : '1rem auto 2rem',
            fontWeight: 400,
            lineHeight: isMobile ? '1.4' : '1.6'
          }}>
            Everything you need to clear Prelims in <strong>ONE</strong> complete program. 
            Stop guessing. Start preparing.
          </p>
          <a 
            href="https://forms.gle/LJjeLHtjCNe5N2z3A" 
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              backgroundColor: '#2563eb',
              color: 'white',
              fontWeight: 700,
              padding: isMobile ? '0.625rem 1.5rem' : '0.75rem 2rem',
              borderRadius: '9999px',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
              textDecoration: 'none',
              fontSize: isMobile ? 'clamp(0.875rem, 2vw, 1rem)' : '1.125rem',
              border: '1px solid rgba(37, 99, 235, 0.5)',
              transition: 'all 0.3s',
              transform: 'translateY(0)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1d4ed8';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#2563eb';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Enroll Now
          </a>
        </div>
      </header>

      {/* Features Grid */}
      <section style={{
        maxWidth: '1152px',
        margin: '0 auto',
        padding: isMobile ? '0 1rem' : '0 1.5rem',
        marginTop: isMobile ? '-2rem' : '-4rem',
        position: 'relative',
        zIndex: 20,
        marginBottom: isMobile ? '2rem' : '4rem'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: isMobile ? '0.75rem' : '1rem',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
          padding: isMobile ? '1.25rem' : '2rem',
          border: '1px solid #f1f5f9',
          textAlign: 'center'
        }}>
          <h2 style={{
            fontSize: isMobile ? 'clamp(1.5rem, 3vw, 1.75rem)' : '1.75rem',
            fontWeight: 700,
            color: '#1e293b',
            display: 'inline-block',
            border: '3px solid #dc2626',
            borderRadius: '50px',
            padding: isMobile ? '0.5rem 1.5rem' : '0.75rem 2rem',
            marginBottom: isMobile ? '2rem' : '3rem'
          }}>
            Program Features
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: isMobile ? '0.75rem' : '1.5rem',
            width: '100%'
          }} className="program-features-grid">
            {[
              { icon: '👔', title: '1-to-1 Mentorship', desc: 'Personalized guidance to keep you on track.', color: '#3b82f6' },
              { icon: '📖', title: 'Enriched Material', desc: 'Focused specifically on Prelims high-yield areas.', color: '#14b8a6' },
              { icon: '🎥', title: 'Discussion Videos', desc: 'Comprehensive analysis after every test.', color: '#6366f1' },
              { icon: '📄', title: 'Detailed Synopsis', desc: 'In-depth explanations for all questions.', color: '#f97316' },
              { icon: '📊', title: '4-Round Coverage', desc: 'Efficient, structured, and scientific progression.', color: '#ef4444' },
              { icon: '📈', title: 'Eco Survey + Budget', desc: 'Dedicated test with specialized material.', color: '#10b981' }
            ].map((feature, idx) => (
              <div key={idx} style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: isMobile ? '0.5rem' : '1rem',
                padding: isMobile ? '0.75rem' : '1rem',
                borderRadius: isMobile ? '0.375rem' : '0.5rem',
                flexDirection: isMobile ? 'column' : 'row',
                textAlign: isMobile ? 'center' : 'left',
                border: `3px solid ${feature.color}`,
                backgroundColor: '#ffffff',
                boxShadow: `0 0 10px ${feature.color}40, 0 0 20px ${feature.color}30`
              }}>
                <div style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  color: feature.color,
                  padding: isMobile ? '0.5rem' : '0.75rem',
                  borderRadius: isMobile ? '0.375rem' : '0.5rem',
                  fontSize: isMobile ? '1.25rem' : '1.25rem',
                  margin: isMobile ? '0 auto 0.5rem' : '0'
                }}>
                  {feature.icon}
                </div>
                <div style={{ flex: 1 }}>
                  <h3 style={{ 
                    fontWeight: 700, 
                    color: '#0f172a', 
                    marginBottom: isMobile ? '0.125rem' : '0.25rem',
                    fontSize: isMobile ? 'clamp(1rem, 2vw, 1.125rem)' : 'clamp(1rem, 2vw, 1.125rem)'
                  }}>
                    {feature.title}
                  </h3>
                  <p style={{ 
                    fontSize: isMobile ? 'clamp(0.875rem, 1.5vw, 1rem)' : '1rem', 
                    color: '#475569',
                    lineHeight: isMobile ? '1.3' : '1.5'
                  }}>
                    {feature.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
          
          <div style={{
            marginTop: isMobile ? '1.25rem' : '2rem',
            padding: isMobile ? '0.75rem' : '1rem',
            backgroundColor: '#fef3c7',
            border: '1px solid #fde68a',
            borderRadius: isMobile ? '0.375rem' : '0.5rem',
            fontSize: isMobile ? 'clamp(0.9rem, 1.5vw, 1rem)' : '1rem',
            color: '#92400e',
            display: 'flex',
            alignItems: 'center',
            gap: isMobile ? '0.5rem' : '0.75rem',
            flexDirection: isMobile ? 'column' : 'row',
            textAlign: isMobile ? 'center' : 'left'
          }}>
            <span style={{ fontSize: isMobile ? '1rem' : '1.125rem' }}>ℹ️</span>
            <span>
              <strong>Bonus:</strong> Includes 3 High-Yield Area–Based Current Affairs Tests & dedicated rounds covering PYQ themes.
            </span>
          </div>
        </div>
      </section>

      {/* Motivation Stats Section */}
      <section style={{
        backgroundColor: '#2563eb',
        color: 'white',
        padding: '4rem 1.5rem',
        marginBottom: '4rem',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          maxWidth: '1280px',
          margin: '0 auto',
          position: 'relative',
          zIndex: 10,
          textAlign: 'center'
        }}>
          <h2 style={{
            fontSize: '1.875rem',
            fontWeight: 700,
            marginBottom: '2.5rem',
            color: 'white'
          }}>
            Why You Will Win
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: isMobile ? '0.75rem' : '2rem',
            textAlign: 'center',
            marginBottom: '3rem',
            justifyItems: 'stretch'
          }}>
            {[
              { number: '27', label: 'GS Tests', desc: 'Covering every nook, cranny, and high-yield topic.', color: 'white' },
              { number: '18', label: 'CSAT Tests', desc: 'Eliminate the fear. Master the aptitude.', color: 'white' },
              { number: '45', label: 'Total Tests', desc: "Practice isn't just a part of the process. It IS the process.", color: '#fbbf24' }
            ].map((stat, idx) => (
              <div key={idx} style={{
                padding: isMobile ? '1rem' : '1.5rem',
                backgroundColor: 'rgba(30, 58, 138, 0.5)',
                borderRadius: isMobile ? '0.75rem' : '1rem',
                border: '1px solid rgba(59, 130, 246, 0.3)',
                backdropFilter: 'blur(4px)',
                transition: 'transform 0.3s',
                cursor: 'pointer',
                gridColumn: isMobile && idx === 2 ? '1 / -1' : 'auto',
                justifySelf: isMobile && idx === 2 ? 'center' : 'stretch',
                maxWidth: isMobile && idx === 2 ? '50%' : 'none'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              >
                <div style={{
                  fontSize: isMobile ? 'clamp(2rem, 5vw, 2.5rem)' : '3.75rem',
                  fontWeight: 800,
                  marginBottom: isMobile ? '0.375rem' : '0.5rem',
                  color: stat.color
                }}>
                  {stat.number}
                </div>
                <div style={{
                  fontSize: isMobile ? 'clamp(0.875rem, 2vw, 1rem)' : '1.25rem',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  marginBottom: isMobile ? '0.375rem' : '0.5rem'
                }}>
                  {stat.label}
                </div>
                <p style={{
                  color: '#bfdbfe',
                  fontSize: isMobile ? 'clamp(0.7rem, 1.5vw, 0.8rem)' : '0.875rem',
                  lineHeight: isMobile ? '1.3' : '1.5'
                }}>
                  {stat.desc}
                </p>
              </div>
            ))}
          </div>
          <p style={{
            marginTop: '3rem',
            fontSize: '1.25rem',
            fontWeight: 500,
            fontStyle: 'italic',
            opacity: 0.9,
            maxWidth: '768px',
            margin: '3rem auto 0',
            lineHeight: 1.75
          }}>
            "The distance between your dreams and reality is called action." <br />
            <span style={{
              fontStyle: 'normal',
              fontSize: '1rem',
              marginTop: '0.75rem',
              display: 'block',
              fontWeight: 700,
              letterSpacing: '0.025em',
              color: '#00f0ff',
              textShadow: '0 0 10px #00f0ff, 0 0 20px #00f0ff, 0 0 30px #00f0ff, 0 0 40px #ff00ff, 0 0 50px #ff00ff, 0 0 60px #00ff00'
            }}>
              — DON'T JUST PLAN IT. DO IT. SECURE YOUR RANK WITH ADHVA TODAY.
            </span>
          </p>
        </div>
        <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          fontSize: '9rem',
          color: '#1e3a8a',
          opacity: 0.1,
          transform: 'translate(25%, -25%)'
        }}>
          🏆
        </div>
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          fontSize: '9rem',
          color: '#1e3a8a',
          opacity: 0.1,
          transform: 'translate(-25%, 25%)'
        }}>
          🎯
        </div>
      </section>

      {/* Schedule Section */}
      <main style={{
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '0 1.5rem 5rem',
        textAlign: 'center'
      }}>
        <div style={{
          display: 'inline-block',
          border: '3px solid #dc2626',
          borderRadius: '50px',
          padding: isMobile ? '1rem 2rem' : '1.5rem 3rem',
          margin: '0 auto 3rem',
          textAlign: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <h2 style={{
            fontSize: isMobile ? 'clamp(1.25rem, 3vw, 1.5rem)' : '1.875rem',
            fontWeight: 800,
            textAlign: 'center',
            marginBottom: '0.5rem',
            color: '#0f172a',
            margin: '0 0 0.5rem 0'
          }}>
            Master Test Schedule
          </h2>
          <p style={{
            textAlign: 'center',
            color: '#64748b',
            margin: '0',
            fontSize: isMobile ? 'clamp(0.875rem, 2vw, 1rem)' : '1rem'
          }}>
            Your roadmap to success.
          </p>
        </div>

        {/* Round 1 */}
        <div style={{
          marginBottom: '3rem',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
          borderRadius: '0.75rem',
          overflow: 'hidden',
          border: '1px solid #e2e8f0',
          backgroundColor: 'white'
        }}>
          <div style={{
            backgroundColor: '#2563eb',
            color: 'white',
            padding: '1.5rem'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              textAlign: 'center'
            }}>
              <h3 style={{
                fontSize: '1.25rem',
                fontWeight: 700,
                color: '#fbbf24',
                margin: '0 0 0.5rem 0'
              }}>
                ROUND 1 — FOUNDATION TESTS
              </h3>
              <p style={{
                color: 'white',
                fontSize: '0.875rem',
                margin: '0'
              }}>
                Build your basics. Strengthen the core.
              </p>
            </div>
          </div>
          <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{
              width: 'auto',
              maxWidth: isMobile ? '100%' : 'none',
              margin: '0 auto',
              textAlign: 'left',
              borderCollapse: 'collapse',
              tableLayout: 'auto',
              borderSpacing: 0
            }}>
              <thead>
                <tr style={{
                  backgroundColor: '#f8fafc',
                  fontSize: isMobile ? 'clamp(0.65rem, 2vw, 0.7rem)' : '0.75rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  color: '#64748b',
                  borderBottom: '2px solid #e2e8f0'
                }}>
                  <th style={{ padding: isMobile ? '0.75rem 0.5rem' : '0.75rem', fontWeight: 600, width: 'auto', whiteSpace: 'nowrap' }}>Date</th>
                  <th style={{ padding: isMobile ? '0.75rem 0.5rem' : '0.75rem', fontWeight: 600, width: 'auto', whiteSpace: 'nowrap' }}>Test Code</th>
                  <th style={{ padding: isMobile ? '0.75rem 0.5rem' : '0.75rem', fontWeight: 600, width: 'auto' }}>Coverage</th>
                </tr>
              </thead>
              <tbody style={{
                fontSize: isMobile ? 'clamp(0.75rem, 2vw, 0.8rem)' : '0.875rem'
              }}>
                {[
                  { date: '14 Dec', code: 'Geography-1', coverage: 'Physical Geography (Basics to Climate)', type: 'gs' },
                  { date: '21 Dec', code: 'Geography-2', coverage: 'India + World Geography', type: 'gs' },
                  { date: '21 Dec', code: 'CSAT-1', coverage: 'RC + Basic Maths', type: 'csat' },
                  { date: '28 Dec', code: 'Polity-1', coverage: 'Constitution, FR, DPSP, Duties', type: 'gs' },
                  { date: '04 Jan', code: 'Polity-2', coverage: 'Govt, Parliament, Judiciary', type: 'gs' },
                  { date: '04 Jan', code: 'CSAT-2', coverage: 'Reasoning + RC', type: 'csat' },
                  { date: '11 Jan', code: 'Economy-1', coverage: 'NI, Banking, Budget, Inflation', type: 'gs' },
                  { date: '14 Jan', code: 'CA-1', coverage: 'May–Aug 2025 Current Affairs', type: 'ca' },
                  { date: '18 Jan', code: 'Economy-2', coverage: 'Agriculture to External Sector', type: 'gs' },
                  { date: '18 Jan', code: 'CSAT-3', coverage: 'Quant + DI', type: 'csat' },
                  { date: '25 Jan', code: 'History-1', coverage: 'Ancient + Medieval', type: 'gs' },
                  { date: '01 Feb', code: 'History-2', coverage: 'Modern India + Culture', type: 'gs' },
                  { date: '01 Feb', code: 'CSAT-4', coverage: 'RC + Analytical', type: 'csat' },
                  { date: '08 Feb', code: 'Environment', coverage: 'Ecology, CC, Pollution', type: 'gs' },
                  { date: '15 Feb', code: 'Sci & Tech', coverage: 'Biotech, Space, AI, Defence', type: 'gs' },
                  { date: '15 Feb', code: 'CSAT-5', coverage: 'DI + Quant', type: 'csat' }
                ].map((test, idx) => (
                  <tr key={idx} style={{
                    borderBottom: '1px solid #f1f5f9',
                    backgroundColor: test.type === 'csat' ? '#f8fafc' : test.type === 'ca' ? '#fef3c7' : 'white'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f1f5f9'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = test.type === 'csat' ? '#f8fafc' : test.type === 'ca' ? '#fef3c7' : 'white'}
                  >
                    <td style={{
                      padding: isMobile ? '0.75rem 0.5rem' : '0.75rem',
                      fontWeight: 700,
                      color: '#334155',
                      width: 'auto',
                      whiteSpace: 'nowrap'
                    }}>
                      {test.date}
                    </td>
                    <td style={{
                      padding: isMobile ? '0.75rem 0.5rem' : '0.75rem',
                      color: test.type === 'csat' ? '#64748b' : test.type === 'ca' ? '#a16207' : '#1e40af',
                      fontWeight: 500,
                      width: 'auto',
                      whiteSpace: 'nowrap'
                    }}>
                      {test.code}
                    </td>
                    <td style={{
                      padding: isMobile ? '0.75rem 0.5rem' : '0.75rem',
                      color: test.type === 'csat' ? '#475569' : '#334155',
                      wordWrap: 'break-word',
                      lineHeight: '1.5',
                      width: 'auto'
                    }}>
                      {test.coverage}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Round 2 */}
        <div style={{
          marginBottom: '3rem',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
          borderRadius: '0.75rem',
          overflow: 'hidden',
          border: '1px solid #e2e8f0',
          backgroundColor: 'white'
        }}>
          <div style={{
            backgroundColor: '#059669',
            color: 'white',
            padding: '1.5rem'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              textAlign: 'center'
            }}>
              <h3 style={{
                fontSize: '1.25rem',
                fontWeight: 700,
                color: 'white',
                margin: '0 0 0.5rem 0'
              }}>
                ROUND 2 — SUBJECT FULL-LENGTH TESTS
              </h3>
              <p style={{
                color: 'white',
                fontSize: '0.875rem',
                margin: '0'
              }}>
                Complete mastery of each subject.
              </p>
            </div>
          </div>
          <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{
              width: 'auto',
              maxWidth: isMobile ? '100%' : 'none',
              margin: '0 auto',
              textAlign: 'left',
              borderCollapse: 'collapse',
              tableLayout: 'auto',
              borderSpacing: 0
            }}>
              <thead>
                <tr style={{
                  backgroundColor: '#f8fafc',
                  fontSize: isMobile ? 'clamp(0.65rem, 2vw, 0.7rem)' : '0.75rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  color: '#64748b',
                  borderBottom: '2px solid #e2e8f0'
                }}>
                  <th style={{ padding: isMobile ? '0.75rem 0.5rem' : '0.75rem', fontWeight: 600, width: 'auto', whiteSpace: 'nowrap' }}>Date</th>
                  <th style={{ padding: isMobile ? '0.75rem 0.5rem' : '0.75rem', fontWeight: 600, width: 'auto', whiteSpace: 'nowrap' }}>Test Code</th>
                  <th style={{ padding: isMobile ? '0.75rem 0.5rem' : '0.75rem', fontWeight: 600, width: 'auto' }}>Coverage</th>
                </tr>
              </thead>
              <tbody style={{
                fontSize: isMobile ? 'clamp(0.75rem, 2vw, 0.8rem)' : '0.875rem'
              }}>
                {[
                  { date: '22 Feb', code: 'Geo FLT', coverage: 'Full Geography', type: 'gs' },
                  { date: '22 Feb', code: 'CSAT-6', coverage: 'Full-length', type: 'csat' },
                  { date: '01 Mar', code: 'Polity FLT', coverage: 'Polity + Governance', type: 'gs' },
                  { date: '01 Mar', code: 'CSAT-7', coverage: 'Full-length', type: 'csat' },
                  { date: '08 Mar', code: 'Economy FLT', coverage: 'Full Economy', type: 'gs' },
                  { date: '08 Mar', code: 'CSAT-8', coverage: 'Full-length', type: 'csat' },
                  { date: '11 Mar', code: 'CA-2', coverage: 'Sep–Dec 2025 Current Affairs', type: 'ca' },
                  { date: '15 Mar', code: 'History FLT', coverage: 'Full History + Culture', type: 'gs' },
                  { date: '15 Mar', code: 'CSAT-9', coverage: 'Full-length', type: 'csat' },
                  { date: '22 Mar', code: 'Env + S&T FLT', coverage: 'Full Environment + S&T', type: 'gs' },
                  { date: '22 Mar', code: 'CSAT-10', coverage: 'Full-length', type: 'csat' }
                ].map((test, idx) => (
                  <tr key={idx} style={{
                    borderBottom: '1px solid #f1f5f9',
                    backgroundColor: test.type === 'csat' ? '#f8fafc' : test.type === 'ca' ? '#fef3c7' : 'white'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f1f5f9'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = test.type === 'csat' ? '#f8fafc' : test.type === 'ca' ? '#fef3c7' : 'white'}
                  >
                    <td style={{
                      padding: isMobile ? '0.75rem 0.5rem' : '0.75rem',
                      fontWeight: 700,
                      color: '#334155',
                      width: 'auto',
                      whiteSpace: 'nowrap'
                    }}>
                      {test.date}
                    </td>
                    <td style={{
                      padding: isMobile ? '0.75rem 0.5rem' : '0.75rem',
                      color: test.type === 'csat' ? '#64748b' : test.type === 'ca' ? '#a16207' : '#047857',
                      fontWeight: 500,
                      width: 'auto',
                      whiteSpace: 'nowrap'
                    }}>
                      {test.code}
                    </td>
                    <td style={{
                      padding: isMobile ? '0.75rem 0.5rem' : '0.75rem',
                      color: test.type === 'csat' ? '#475569' : '#334155',
                      wordWrap: 'break-word',
                      lineHeight: '1.5',
                      width: 'auto'
                    }}>
                      {test.coverage}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Round 3 */}
        <div style={{
          marginBottom: '3rem',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
          borderRadius: '0.75rem',
          overflow: 'hidden',
          border: '1px solid #e2e8f0',
          backgroundColor: 'white'
        }}>
          <div style={{
            backgroundColor: '#f97316',
            color: 'white',
            padding: '1.5rem'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              textAlign: 'center'
            }}>
              <h3 style={{
                fontSize: '1.25rem',
                fontWeight: 700,
                color: 'white',
                margin: '0 0 0.5rem 0'
              }}>
                ROUND 3 — HIGH-YIELD ADVANCED TESTS
              </h3>
              <p style={{
                color: 'white',
                fontSize: '0.875rem',
                margin: '0'
              }}>
                PYQ-driven, exam-focused, high-scoring.
              </p>
            </div>
          </div>
          <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{
              width: 'auto',
              maxWidth: isMobile ? '100%' : 'none',
              margin: '0 auto',
              textAlign: 'left',
              borderCollapse: 'collapse',
              tableLayout: 'auto',
              borderSpacing: 0
            }}>
              <thead>
                <tr style={{
                  backgroundColor: '#f8fafc',
                  fontSize: isMobile ? 'clamp(0.65rem, 2vw, 0.7rem)' : '0.75rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  color: '#64748b',
                  borderBottom: '2px solid #e2e8f0'
                }}>
                  <th style={{ padding: isMobile ? '0.75rem 0.5rem' : '0.75rem', fontWeight: 600, width: 'auto', whiteSpace: 'nowrap' }}>Date</th>
                  <th style={{ padding: isMobile ? '0.75rem 0.5rem' : '0.75rem', fontWeight: 600, width: 'auto', whiteSpace: 'nowrap' }}>Test Code</th>
                  <th style={{ padding: isMobile ? '0.75rem 0.5rem' : '0.75rem', fontWeight: 600, width: 'auto' }}>Coverage</th>
                </tr>
              </thead>
              <tbody style={{
                fontSize: isMobile ? 'clamp(0.75rem, 2vw, 0.8rem)' : '0.875rem'
              }}>
                {[
                  { date: '29 Mar', code: 'Geo HYA', coverage: 'High-Yield + PYQs', type: 'gs' },
                  { date: '29 Mar', code: 'CSAT-11', coverage: 'Full-length', type: 'csat' },
                  { date: '05 Apr', code: 'Polity HYA', coverage: 'High-Yield Polity', type: 'gs' },
                  { date: '05 Apr', code: 'CSAT-12', coverage: 'Full-length', type: 'csat' },
                  { date: '12 Apr', code: 'Economy HYA', coverage: 'High-Yield + Survey', type: 'gs' },
                  { date: '12 Apr', code: 'CSAT-13', coverage: 'Full-length', type: 'csat' },
                  { date: '15 Apr', code: 'Survey + Budget', coverage: 'Economic Survey + Budget (Special Material)', type: 'special' },
                  { date: '19 Apr', code: 'History HYA', coverage: 'High-Yield Themes', type: 'gs' },
                  { date: '19 Apr', code: 'CSAT-14', coverage: 'Full-length', type: 'csat' },
                  { date: '26 Apr', code: 'Env + S&T HYA', coverage: 'High-Yield Themes', type: 'gs' },
                  { date: '26 Apr', code: 'CSAT-15', coverage: 'Full-length', type: 'csat' }
                ].map((test, idx) => (
                  <tr key={idx} style={{
                    borderBottom: '1px solid #f1f5f9',
                    backgroundColor: test.type === 'csat' ? '#f8fafc' : test.type === 'special' ? '#eef2ff' : 'white'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f1f5f9'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = test.type === 'csat' ? '#f8fafc' : test.type === 'special' ? '#eef2ff' : 'white'}
                  >
                    <td style={{
                      padding: isMobile ? '0.75rem 0.5rem' : '0.75rem',
                      fontWeight: 700,
                      color: '#334155',
                      width: 'auto',
                      whiteSpace: 'nowrap'
                    }}>
                      {test.date}
                    </td>
                    <td style={{
                      padding: isMobile ? '0.75rem 0.5rem' : '0.75rem',
                      color: test.type === 'csat' ? '#64748b' : test.type === 'special' ? '#4338ca' : '#c2410c',
                      fontWeight: 500,
                      width: 'auto',
                      whiteSpace: 'nowrap'
                    }}>
                      {test.code}
                    </td>
                    <td style={{
                      padding: isMobile ? '0.75rem 0.5rem' : '0.75rem',
                      color: test.type === 'csat' ? '#475569' : '#334155',
                      wordWrap: 'break-word',
                      lineHeight: '1.5',
                      width: 'auto'
                    }}>
                      {test.coverage}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Round 4 */}
        <div style={{
          marginBottom: '3rem',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
          borderRadius: '0.75rem',
          overflow: 'hidden',
          border: '1px solid #e2e8f0',
          backgroundColor: 'white'
        }}>
          <div style={{
            backgroundColor: '#dc2626',
            color: 'white',
            padding: '1.5rem'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              textAlign: 'center'
            }}>
              <h3 style={{
                fontSize: '1.25rem',
                fontWeight: 700,
                color: 'white',
                margin: '0 0 0.5rem 0'
              }}>
                ROUND 4 — FINAL MOCKS
              </h3>
              <p style={{
                color: 'white',
                fontSize: '0.875rem',
                fontWeight: 700,
                margin: '0'
              }}>
                Simulate the real exam. Fix last gaps.
              </p>
            </div>
          </div>
          <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{
              width: 'auto',
              maxWidth: isMobile ? '100%' : 'none',
              margin: '0 auto',
              textAlign: 'left',
              borderCollapse: 'collapse',
              tableLayout: 'auto',
              borderSpacing: 0
            }}>
              <thead>
                <tr style={{
                  backgroundColor: '#f8fafc',
                  fontSize: isMobile ? 'clamp(0.65rem, 2vw, 0.7rem)' : '0.75rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  color: '#64748b',
                  borderBottom: '2px solid #e2e8f0'
                }}>
                  <th style={{ padding: isMobile ? '0.75rem 0.5rem' : '0.75rem', fontWeight: 600, width: 'auto', whiteSpace: 'nowrap' }}>Date</th>
                  <th style={{ padding: isMobile ? '0.75rem 0.5rem' : '0.75rem', fontWeight: 600, width: 'auto', whiteSpace: 'nowrap' }}>Test Code</th>
                  <th style={{ padding: isMobile ? '0.75rem 0.5rem' : '0.75rem', fontWeight: 600, width: 'auto' }}>Coverage</th>
                </tr>
              </thead>
              <tbody style={{
                fontSize: isMobile ? 'clamp(0.75rem, 2vw, 0.8rem)' : '0.875rem'
              }}>
                {[
                  { date: '03 May', code: 'GS Mock-1', coverage: 'UPSC Simulation 1', type: 'mock', highlight: true },
                  { date: '03 May', code: 'CSAT-16', coverage: 'Full-length', type: 'csat' },
                  { date: '06 May', code: 'CA-3', coverage: 'Jan–Apr 2026 Current Affairs', type: 'ca' },
                  { date: '10 May', code: 'GS Mock-2', coverage: 'UPSC Simulation 2', type: 'mock', highlight: true },
                  { date: '10 May', code: 'CSAT-17', coverage: 'Full-length', type: 'csat' },
                  { date: '17 May', code: 'GS Mock-3', coverage: 'Final UPSC Mock', type: 'mock', highlight: true, final: true },
                  { date: '17 May', code: 'CSAT-18', coverage: 'Full-length', type: 'csat' }
                ].map((test, idx) => (
                  <tr key={idx} style={{
                    borderBottom: '1px solid #f1f5f9',
                    backgroundColor: test.type === 'csat' ? '#f8fafc' : test.type === 'ca' ? '#fef3c7' : test.highlight ? (test.final ? '#fee2e2' : '#fef2f2') : 'white'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = test.highlight ? '#fee2e2' : '#f1f5f9'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = test.type === 'csat' ? '#f8fafc' : test.type === 'ca' ? '#fef3c7' : test.highlight ? (test.final ? '#fee2e2' : '#fef2f2') : 'white'}
                  >
                    <td style={{
                      padding: isMobile ? '0.75rem 0.5rem' : '0.75rem',
                      fontWeight: 700,
                      color: '#334155',
                      width: 'auto',
                      whiteSpace: 'nowrap'
                    }}>
                      {test.date}
                    </td>
                    <td style={{
                      padding: isMobile ? '0.75rem 0.5rem' : '0.75rem',
                      color: test.type === 'csat' ? '#64748b' : test.type === 'ca' ? '#a16207' : '#991b1b',
                      fontWeight: test.highlight ? 800 : 500,
                      width: 'auto',
                      whiteSpace: 'nowrap'
                    }}>
                      {test.code}
                    </td>
                    <td style={{
                      padding: isMobile ? '0.75rem 0.5rem' : '0.75rem',
                      color: test.highlight ? '#7f1d1d' : (test.type === 'csat' ? '#475569' : '#334155'),
                      fontWeight: test.highlight ? (test.final ? 700 : 500) : 'normal',
                      wordWrap: 'break-word',
                      lineHeight: '1.5',
                      width: 'auto'
                    }}>
                      {test.coverage}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>

      {/* Footer / CTA */}
      <footer style={{
        backgroundColor: '#0f172a',
        color: 'white',
        padding: '4rem 1.5rem',
        textAlign: 'center'
      }}>
        <div style={{
          maxWidth: '1024px',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontSize: '1.875rem',
            fontWeight: 700,
            marginBottom: '1rem',
            color: 'white'
          }}>
            Prelims is predictable — when your preparation is structured.
          </h2>
          <p style={{
            color: '#fbbf24',
            marginBottom: '2rem',
            fontSize: '1.125rem',
            fontWeight: 700
          }}>
            Your Blueprint to Clear the UPSC Prelims 2026.
          </p>
          
          <div style={{
            marginBottom: '2.5rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            <span style={{
              backgroundColor: '#10b981',
              color: 'white',
              fontSize: '0.75rem',
              fontWeight: 700,
              padding: '0.25rem 0.75rem',
              borderRadius: '9999px',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              marginBottom: '0.5rem',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
            }}>
              Early Join Offer
            </span>
            <div style={{
              display: 'flex',
              alignItems: 'baseline',
              gap: '0.75rem'
            }}>
              <span style={{
                fontSize: '1.5rem',
                color: 'white',
                textDecoration: 'line-through',
                fontWeight: 500
              }}>
                ₹4999
              </span>
              <span style={{
                fontSize: '3rem',
                fontWeight: 800,
                color: 'white',
                letterSpacing: '-0.025em'
              }}>
                ₹3999
              </span>
            </div>
          </div>

          <a 
            href="https://forms.gle/LJjeLHtjCNe5N2z3A" 
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              backgroundColor: '#2563eb',
              color: 'white',
              fontWeight: 700,
              padding: '1rem 2.5rem',
              borderRadius: '9999px',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
              textDecoration: 'none',
              fontSize: '1.125rem',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1d4ed8';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#2563eb';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Enroll Now
          </a>
          <p style={{
            marginTop: '2rem',
            fontSize: '0.875rem',
            color: '#475569'
          }}>
            Adhva Academy
          </p>
        </div>
      </footer>

      <Footer />

      {/* Ensure 2-column grid on mobile for Program Features */}
      <style>{`
        @media (max-width: 768px) {
          .program-features-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
      `}</style>
    </div>
  );
};

export default AdhvaPrelimsPath2026Page;
